import { configWithUserToken } from "./config";

export interface HealthCheck {
  name: string;
  status: string;
  description?: string;
  duration: string;
  data?: Record<string, string | number>;
}

export interface HealthResponse {
  status: string;
  totalDuration: string;
  checks: HealthCheck[];
}

export const getHealthAll = () =>
  configWithUserToken.get<HealthResponse>("Health/all");
